import { blockbiteEditorBodyClass } from '@core/blockbite.ts';
import './blockbite-editor.css';
import { initBlockExtend } from '@core/blockExtend.js';
import { registerBlockbiteVariations } from '@core/blockVariations.js';
import { blockbitePurge } from '@core/blockbitePurge.ts';
import { blockbiteRegisterSidebar } from '@components/Sidebar/sideBarRegister.js';
import { initBlockSupport } from '@components/Settings/BlockSupport/BlockSupport';
import { register } from '@wordpress/data';
import { presetStore } from '@components/PresetPanel/presetStore';
import { biteStore } from '@store/biteStore';
import { InitBitesLibrary } from '@components/Library/init.js';
import Codex from '@codex/codex.json';

// make globally available
blockbite.codex = Codex;

import {
  updateColors,
  updateFontFamilies,
  updateFontSizes,
} from '@tailwind/config';
import { current } from 'tailwindcss/colors';

register(presetStore);
register(biteStore);

/*
import { blockbiteRecoverCheck } from "../plugins/blockbiteRecoverCheck.js";
*/

/**
 *
 */

initBlockSupport();
initBlockExtend();

// get biteStore/editor default data
wp.data.select('biteStore/editor').getAll();

wp.data.subscribe(() => {
  const { getDevice, getEditorType, getEditorMode } =
    wp.data.select('biteStore/editor');

  const editorType = getEditorType();
  const editorMode = getEditorMode();
  const device = getDevice();
  /**
   * Saving hook
   */
  if (blockbite.getSaveState() && !blockbite.saving) {
    blockbite.saving = true;
    blockbitePurge();
  }
  /**
   * Rendering Components
   */
  blockbiteRegisterSidebar();
  // update screen
  const currentDevice = blockbite.getDeviceType();
  const currentEditorType = blockbite.getEditorType();
  const currentEditorMode = blockbite.getEditorMode();

  if (device !== currentDevice) {
    wp.data.dispatch('biteStore/editor').setDevice(currentDevice);
  }
  if (editorType !== currentEditorType) {
    wp.data.dispatch('biteStore/editor').setEditorType(currentEditorType);
  }
  if (editorMode !== currentEditorMode) {
    wp.data.dispatch('biteStore/editor').setEditorMode(currentEditorMode);
  }

  InitBitesLibrary();
});

wp.domReady(() => {
  registerBlockbiteVariations();
});
